import React, {useEffect, useState, useContext} from 'react'
import _ from 'lodash'
import {Modal} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import {searchEntityFieldTypes} from '../../../../state/entities/search-entity-field-types/actions'
import useSearchEntityFieldTypesReducer from '../../../../state/entities/search-entity-field-types/reducer'

// Custom Components
import '../ShareableView.scss'
import {
  createShareableView,
  updateShareableView,
} from '../../../../state/calendar-views/post-shareable-calendar/actions'
import usePostShareableViewReducer from '../../../../state/calendar-views/post-shareable-calendar/reducer'
import useCalendarViewContext from '../../../../context/CalendarView'
import {deleteShareableCalendarView} from '../../../../state/calendar-views/delete-shareable-view/actions'
import useDeleteShareableCalendarViewReducer from '../../../../state/calendar-views/delete-shareable-view/reducer'

import {useModal} from '../../../../common/Modal'
import {ToastMessageContext} from '../../../../context/ToastMessage/ToastMessage'
import {useTranslation} from 'react-i18next'
import clsx from 'clsx'
import {DatesToDisplay} from '../../Views/PopGroupView/DatesToDisplay'
import {Select} from '../../Views/PopGroupView/Select'
import {Filters} from '../../Views/PopGroupView/Filters'
import {DisplayFields} from '../../Views/PopGroupView/DisplayFields'
import {ViewColor} from '../../Views/ViewColor'
// styles
const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginLeft: 0,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  root: {
    // focused color for input with variant='standard'
    '& .MuiInput-underline:after': {
      borderBottomColor: '#c4c4c4',
    },
    // focused color for input with variant='filled'
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: '#c4c4c4',
    },
    // focused color for input with variant='outlined'
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#c4c4c4',
      },
    },
  },
}))

const ShareableViewPopup = ({
  open,
  onClose,
  data,
  groups,
  onSuccess,
  customColors = [],
  viewData,
  shareableViews,
  editInfo,
  setCurrentColor,
}) => {
  const {t} = useTranslation()
  const simpleModal = useModal()
  const ctxToast = useContext(ToastMessageContext)
  const [refColorPicker, setRefColorPicker] = useState(null)
  const [group, groupDispatch] = useSearchEntityFieldTypesReducer()
  const [save, saveDispatch] = usePostShareableViewReducer()
  const [remove, deleteDispatch] = useDeleteShareableCalendarViewReducer()

  const {sharableEntityFields, setSharableFilters, setViewData} = useCalendarViewContext()

  const [groupView, setGroupView] = useState({
    // user_id: 133619,
    entity_id: -1,
    color: '#f2c2c0',
    groups: [],
    actions: [],
    name: '',
    display_fields: [],
  })
  const [errorMsg, setErrorMsg] = useState('')

  const entity_view_ids = _.map(shareableViews, (val, key) => {
    return val.group_view.entity_id
  })

  const update = (e, k, v) => {
    setGroupView(p => ({...p, [k]: v}))
  }

  const handleClickColorPicker = e => {
    setRefColorPicker(e.target)
  }

  const handleChangeViewName = e => {
    update(e, 'name', e.target.value)
    setErrorMsg('')
  }

  const handleChangeGroup = (e, item) => {
    update(e, 'entity_id', item.id)
    // update(e, 'entity_id', e.target.value)
  }

  const handleChangeFilters = (e, v) => {
    update(e, 'filters', v)
  }
  const handleSetDisplayFields = (e, v) => {
    update(e, 'display_fields', v)
  }

  // trigger load group data
  useEffect(() => {
    if (groupView?.entity_id && groupView.entity_id !== -1) {
      searchEntityFieldTypes(groupDispatch, groupView.entity_id, {
        include_actions: false,
        include_related: true,
        field_types: ['DateField', 'DateFormulaField', 'CreatedAtField', 'DateTimeField'],
        currency_items: false,
        with_actions: true,
      })
    }
    // eslint-disable-next-line
  }, [groupView.entity_id, groupDispatch])

  //
  useEffect(() => {
    if (!_.isEmpty(group.data)) {
      const _groups = _.map(group.data.fields, f => ({
        field_id: f.id,
        key: f.key,
        active: false,
      }))
      const _actions = _.map(group.data.actions || [], a => ({
        action_id: a.id,
        active: false,
      }))

      setGroupView(p => ({
        ...p,
        groups: _groups.map(
          g => (p?.groups && p?.groups.find(pg => pg.field_id === g.field_id)) || g
        ),
        actions: _actions.map(
          a => (p?.actions && p?.actions.find(pa => pa.action_id === a.action_id)) || a
        ),
      }))
    }
  }, [group.data, setGroupView])

  // initialize for mounting
  useEffect(() => {
    if (editInfo?.id) {
      let _data = _.pick(editInfo, [
        'user_id',
        'entity_id',
        'color',
        'groups',
        'actions',
        'name',
        'filters',
        'display_fields',
      ])
      if (editInfo.id) {
        _data['id'] = editInfo.id
      }
      setGroupView({..._data})
    }
  }, [editInfo])

  var isDiableGroupAction = true

  groupView?.actions &&
    groupView.actions.map(action_data => {
      if (action_data.active) {
        isDiableGroupAction = false
      }
      return isDiableGroupAction
    })

  groupView?.groups &&
    groupView.groups.map(group_data => {
      if (group_data.active) {
        isDiableGroupAction = false
      }
      return isDiableGroupAction
    })

  const isDisablebtn = groupView.name !== '' && groupView.entity_id !== -1

  const handleConfirm = e => {
    const _confirmFunc = !groupView.id ? createShareableView : updateShareableView
    _confirmFunc(saveDispatch, {
      user_id: localStorage.user_id,
      ...groupView,
    })
      .then(res => {
        onSuccess('create', res.data)
        setCurrentColor(groupView.color)
      })
      .catch(e => {
        console.log('e.data.errors.name', e)
        if (e.data && e.data.errors.name) {
          setErrorMsg('This view name already exists.')
        }
      })
  }

  const onDelete = e => {
    const temp_data = {
      id: editInfo.id['$oid'],
      editInfo,
    }
    if (simpleModal) {
      simpleModal.show({
        scheme: 'destructive',
        title: 'Delete View',
        description: 'Are you sure you want to delete this shareable view?',
        buttons: {
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              deleteShareableCalendarView(deleteDispatch, temp_data).then(res => {
                onSuccess('delete')
                ctxToast.popMessage(res.message, 'success', null)
              })
              modal.hide()
            },
          },
          negative: {
            label: 'No',
          },
        },
      })
    }
  }

  useEffect(() => {
    const _sharableFilter = []
    groupView?.filters &&
      groupView.filters.map(f => {
        const field = sharableEntityFields.find(option => option.field_id === f.field_id)
        if (field) {
          const value_arr = []
          !_.isEmpty(f.values) && f.values.map(val => value_arr.push(val.id))
          return _sharableFilter.push({
            id: f.field_id,
            field_name: field?.field_name,
            key: f.key,
            value: value_arr,
            values: !_.isEmpty(f.values) && f.values[0],
            new_values: f.values,
          })
        } else {
          return ''
        }
      })
    if (_sharableFilter.length > 0) {
      setSharableFilters(_sharableFilter)
      setViewData({
        ...viewData,
        selectedFilterValueFields: _sharableFilter,
        selectedFilteredViews: [],
      })
    }

    // eslint-disable-next-line
  }, [groupView.filters, setSharableFilters, setViewData, sharableEntityFields])

  const handleSetActionAdvOpt = (e, k, v) => {
    const _actions = [...groupView.actions]
    _actions[k].advance_option_key = v
    update(e, 'actions', _actions)
  }

  const handleToggleGroup = (e, k, v) => {
    const _groups = [...groupView.groups]
    _groups[k].active = v
    update(e, 'groups', _groups)
  }

  const handleToggleActions = (e, k, v) => {
    const _actions = [...groupView.actions]
    _actions[k].active = v
    _actions[k].advance_option_key = {start_date: '', end_date: '', is_stamp: true}
    update(e, 'actions', _actions)
  }

  const isEdit = editInfo?.entity_id

  return (
    <Modal
      style={{position: 'absolute'}}
      className={'ds-modal-wrapper'}
      open={open}
      onClose={onClose}
    >
      <div className="ds-modal-complex ds-modal-complex--lg ds-py-0">
        <div className="ds-flex-row ds-flex-no-spill">
          <div
            className="ds-flex-col ds-flex-no-spill ds-pt-24 ds-pb-20"
            style={{
              flex: '0 0 517px',
              borderRight: '1px solid #D6D8DC',
              paddingRight: 30,
            }}
          >
            <div
              className="ds-modal-header ds-mb-52"
              style={{display: 'flex', justifyContent: 'space-between'}}
            >
              <h4 className="ds-t400r">
                {!isEdit
                  ? t('calendar.shareable-view.add.title')
                  : t('calendar.shareable-view.edit.title')}
              </h4>
              <ViewColor value={groupView.color} onChange={(e, v) => update(e, 'color', v)} />
            </div>
            <div className="ds-modal-body ds-flex-col ds-mb-32">
              <div className="ds-mb-12">
                <fieldset
                  className={clsx('ds-form-input', {
                    'ds-form-input--error': !!errorMsg,
                  })}
                  required
                >
                  <legend>{t('calendar.shareable-view.add.txt-name')}</legend>
                  <input
                    className="ds-mr-8"
                    value={groupView.name}
                    onChange={handleChangeViewName}
                  />
                </fieldset>
                <div className="ds-tip" hidden={!!!errorMsg}>
                  <i className="ds-icon-error ds-tr100"></i>
                  <span>{errorMsg}</span>
                </div>
              </div>
              <Select
                disabled={isEdit}
                value={groupView.entity_id}
                label={t('calendar.shareable-view.add.sel-group')}
                required
                placeholder={t('calendar.view.add.placeholder-select-field')}
                onChange={handleChangeGroup}
                items={groups.data}
                render={(item, index, clickHandle) => {
                  return (
                    <div
                      key={index}
                      onClick={e => clickHandle(e, item, index)}
                      className="ds-menu-item"
                    >
                      {item.name}
                    </div>
                  )
                }}
                selectedDisplay={(value, items) => _.find(items, f => f.id === value)?.name}
              />
              <DatesToDisplay
                entity_id={groupView.entity_id}
                group={group}
                groups={groupView.groups}
                actions={groupView.actions}
                handleToggleActions={handleToggleActions}
                handleToggleGroup={handleToggleGroup}
                handleSetActionAdvOpt={handleSetActionAdvOpt}
              />
            </div>
            <div className="ds-modal-footer" style={{height: 32, justifyContent: 'flex-start'}}>
              {isEdit && (
                <button className="ds-btn-destructive" onClick={onDelete}>
                  {t('calendar.view.edit.btn-delete')}
                </button>
              )}
            </div>
          </div>
          <div className="ds-flex-col ds-pt-48 ds-pb-20 ds-pl-30">
            <div className="ds-modal-body ds-mb-32 ds-flex-col" style={{gap: 24}}>
              <Filters groupView={groupView} onChange={handleChangeFilters} />
              <DisplayFields
                groupView={groupView}
                onChange={handleSetDisplayFields}
                display_fields={groupView.display_fields || []}
              />
            </div>

            <div className="ds-modal-footer">
              <button
                className="ds-btn-cta ds-mr-8"
                onClick={handleConfirm}
                disabled={group.isLoading || !isDisablebtn || isDiableGroupAction}
              >
                {!isEdit ? t('calendar.view.add.btn-create') : t('calendar.view.edit.btn-create')}
              </button>
              <button className="mdl-cancel ds-btn-secondary" onClick={onClose}>
                {t('calendar.view.add.btn-cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ShareableViewPopup
